import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';


import { SplittedInputModule } from 'ib/internetbank-core/ib-components/splitted-input/splitted-input.module';

import { RegistrationProductConfirmationCodeComponent } from './registration-product-confirmation-code.component';

@NgModule({
	imports: [
		CommonModule,
		SplittedInputModule,
		ReactiveFormsModule,
	],
	declarations: [RegistrationProductConfirmationCodeComponent],
	exports: [RegistrationProductConfirmationCodeComponent],
})
export class RegistrationProductConfirmationCodeModule { }
